// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2smyE","title":"BackImages_title__Vbqpf","images":"BackImages_images__2uozL"};